import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import da from './da';
import en from './en';

const LANGS = { da, en };

export const useLang = create(
  persist(
    (set, get) => ({
      lang: 'da',
      setLang: (lang) => set({ lang }),
      t: (key) => {
        const l = get().lang;
        return LANGS[l]?.[key] || LANGS['da']?.[key] || key;
      },
    }),
    { name: 'lang-pref' }
  )
);

// Helper hook - returns t function and lang
export default useLang;
